import { digitalProductDesignData } from "../data/software-apps";
import ProductDesignIcon from "../icons/product-design";

const DigitalProductDesign = () => {
  return (
    <div className="row align-items-center" id="digital-product-design">
      <div className="col-12 col-lg-5 pe-5 text-center text-lg-start">
        <ProductDesignIcon />
        <h2 className="fs-56 lh-64 gilroy-bold py-5 text-danger">
          Digital Product Design
        </h2>
        <p className="fs-16 text-align-justify">
          Turn a crude thought into a item millions can’t live without much
          obliged to our demonstrated 5-stage custom computer program
          advancement handle. Our computer program improvement administrations
          firm planned branding and UX/UI that affected development of financing
          stages, instructive administrations, and indeed a neo-bank. Common
          sense, rehashed utilize, and A-grade speed are fair a handful of Plan
          Considering rules our custom computer program improvement company
          lives by.
        </p>
      </div>
      <div className="col-12 col-lg-7">
        <div className="row">
          <div className="col-12 col-md-6">
            {digitalProductDesignData.slice(0, 3).map((designData) => (
              <div
                key={designData.title}
                className="text-center digital-card border px-4 py-5 my-4 rounded"
              >
                <img
                  src={designData.img}
                  loading="lazy"
                  alt={designData.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{designData.title}</h3>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6 mt-0 mt-md-5">
            {digitalProductDesignData.slice(3, 6).map((designData) => (
              <div
                key={designData.title}
                className="text-center digital-card border px-4 py-5 mb-4 rounded"
              >
                <img
                  src={designData.img}
                  loading="lazy"
                  alt={designData.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{designData.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalProductDesign;
